import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ApprovalListModalComponent } from "./approval-list-modal.component";
import { ApprovalListComponent } from "./approval-list/approval-list.component";
import { TranslateModule } from "@ngx-translate/core";
import { CorePipesModule } from "@core/pipes/pipes.module";
import { CoreDirectivesModule } from "@core/directives/directives";
import { IconsModule } from "app/components/icons";

@NgModule({
  declarations: [ApprovalListComponent, ApprovalListModalComponent],
  imports: [NgxDatatableModule, CommonModule, TranslateModule, CorePipesModule, CoreDirectivesModule, IconsModule],
  exports: [ApprovalListComponent, ApprovalListModalComponent],
})
export class ApprovalListModule {}
